/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { LocalStorageService } from '@hcworkspace/sysque/toolbelt/utils';
import { ConvertOptionReturnCodes } from '../models/place-coupling-return-codes';
import { GlobalConstants } from '../constants/global-constants';

export class PlaceCouplingReceiveController {
  constructor(private localStorageService: LocalStorageService) {}

  public placeCouplingResult(response: ConvertOptionReturnCodes): void {
    this.localStorageService.updateStorage(GlobalConstants.PLACE_COUPLING_RESPONSE, response);
  }

  public convertOptionResult(response: ConvertOptionReturnCodes): void {
    this.localStorageService.updateStorage(GlobalConstants.CONVERT_SYSTEM_RESPONSE, response);
  }
}
